/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Date from './Date/index'
import React from 'react'
import Time from './Time/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails/DateTimeScheduled/Content"
  
}) {
  return (<React.Fragment
>
<Date
  viewPath={`${viewPath}/Date`}
/>
<Time
  viewPath={`${viewPath}/Time`}
/>
{children}
</React.Fragment>)
}